import { createSignal } from "solid-js";
import { calculateCharacterCount, calculateLineCount, hasInputText } from "../utils";

/**
 * Hook for managing prompt input state and calculations
 */
export const usePromptInput = () => {
  const [inputValue, setInputValue] = createSignal("");

  const characterCount = () => calculateCharacterCount(inputValue());
  const lineCount = () => calculateLineCount(inputValue());
  const hasText = () => hasInputText(inputValue());

  return {
    inputValue,
    setInputValue,
    characterCount,
    lineCount,
    hasInputText: hasText,
  };
};
